import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import OrganizationContactPanel from '../../components/Common/OrganizationContactPanel';
import PrivacyDpoContact from '../../components/Common/PrivacyDpoContact';
import PrivacyLegalContent from '../../components/Common/PrivacyLegalContent';
import PublicResourceLinksList from '../../components/Common/PublicResourceLinks';
import PublicLegalPageLayout, {
  LastUpdated,
  List,
  Section,
  SectionTitle,
  Text,
  TextNoMargin
} from '../../components/Common/PublicLegalPageLayout';
import usePublicPagesSettings from '../../hooks/usePublicPagesSettings';
import { formatPrivacyDate } from '../../utils/publicPagesDefaults';

const Confidentialite = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const year = new Date().getFullYear();
  const { settings } = usePublicPagesSettings({ publicAccess: true });
  const locale = i18n.language;

  const meta = settings?.privacy?.meta;
  const metaDisplay = meta
    ? {
        ...meta,
        lastUpdated: formatPrivacyDate(meta.lastUpdated, locale),
        effectiveDate: formatPrivacyDate(meta.effectiveDate, locale)
      }
    : null;

  return (
    <PublicLegalPageLayout
      title={t('privacyPage.title')}
      backLabel={t('privacyPage.back')}
      onBack={() => navigate('/')}
    >
      <PrivacyLegalContent sections={settings?.privacy?.sections} meta={metaDisplay} />

      {settings?.privacy?.resources?.length > 0 && (
        <Section>
          <SectionTitle>{t('publicPages.privacy.resourcesTitle')}</SectionTitle>
          <Text>{t('publicPages.privacy.resourcesIntro')}</Text>
          <PublicResourceLinksList resources={settings.privacy.resources} />
        </Section>
      )}

      <Section>
        <SectionTitle>{t('privacyPage.contact.title')}</SectionTitle>
        <OrganizationContactPanel publicAccess onDark />
        <PrivacyDpoContact />
        <Text><strong>{t('privacyPage.contact.authorityTitle')}</strong></Text>
        <Text>{t('privacyPage.contact.authorityIntro')}</Text>
        <List>
          <li>{t('privacyPage.contact.authorityWebsite')}</li>
          <li>{t('privacyPage.contact.authorityPhone')}</li>
          <li>{t('privacyPage.contact.authorityAddress')}</li>
        </List>
      </Section>

      <LastUpdated>
        <TextNoMargin>
          <strong>{t('privacyPage.footer.appName')}</strong>
          <br />
          {t('privacyPage.footer.rights', { year })}
          <br />
          {metaDisplay?.lastUpdated
            ? `${t('privacyPage.footer.lastUpdated')} ${metaDisplay.lastUpdated}`
            : t('privacyPage.footer.lastUpdated')}
        </TextNoMargin>
      </LastUpdated>
    </PublicLegalPageLayout>
  );
};

export default Confidentialite;
